module.exports = "/images/trialproofer-img.png?4fd5dd207ae0ce867097b47c8b7b8b27";